import { GreenhouseResponse } from "@/types/greenhouse";

/**
 * Greenhouse entry point for all active job listings. Returns a list of jobs
 */
export async function fetchAllGreenhouseJobs(): Promise<GreenhouseResponse> {
    try {
        const _res = await fetch(
            "https://boards-api.greenhouse.io/v1/boards/warp/jobs",
        );

        const _json = await _res.json();

        return _json;
    } catch (error) {
        throw new Error("An error occured during fetchAllGreenhouseJobs.");
    }
}
